import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "./axiosHelper";

// Display all Office List
export const getDrsList = createAsyncThunk('data/getDrsList',
  async(data)=>{
    const res = await axiosInstance.get(`/api/v1/drs-details-OffcieId?OfficeId=${data.OfficeId}`);
      return res.data
  }
)
// getDRSList
export const getAdminDRSList = createAsyncThunk('data/getAdminDRSList',
  async(data)=>{
    const res = await axiosInstance.get(`/api/v1/DRS/getDRSDetails?page=${data.page}&limit=${data.limit}&search=${data.search}&OfficeId=${data.OfficeId}`);
      return res.data
  }
)


export const deleteDrsDetails = createAsyncThunk('data/deleteDrsDetails',
  async(data)=>{
    console.log("datadrs",data)
    const res = await axiosInstance.delete(`/api/v1/DRS/deleteDRSDetails/${data}`);
      return res.data
    }
)
export const createDrsDetails = createAsyncThunk('data/createDrsDetails',
  async(data)=>{
    console.log(data);
    const res = await axiosInstance.post('/api/v1/DRS/createDRSDetails', data);
      return res.data
  }
)

//Update Office Details
export const updateDrsDetails = createAsyncThunk('data/updateOffice',
  async(data)=>{
    const res = await axiosInstance.post('/api/v1/DRS/updateDrsDetails', data);
      return res.data
  }
)


export const fetchAndOpenDrsPdf = createAsyncThunk(
  "pdf/fetchAndOpen",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/api/v1/DRS/getSingleDRSDetails/${data.DrsId}`);
      const pdfUrl = response?.data?.pdfUrl;

      if (pdfUrl) {
        window.open(pdfUrl, "_blank"); // ✅ open in new tab
        return pdfUrl;
      } else {
        return rejectWithValue("PDF URL not found");
      }
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Something went wrong");
    }
  }
);
